import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { useForm } from 'react-hook-form';
import { Logo } from '../components'; // Assuming Logo is a separate component
import { api } from '../services'; // Import your API service
import { useSearchParams } from 'react-router-dom'; 

export const Register = () => {
  const today = new Date();
  const [searchParams] = useSearchParams();
  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
  const navigate = useNavigate();

  // Function to handle form submission
  const onSubmit = async (data) => {
    try {
      console.log('Form Data:', data); // Log form data for debugging
      const phoneNumber=searchParams.get('phoneNumber')
      // firstName: data.firstName,
      // lastName: data.lastName,
      // birthDate: data.birthDate,
      // nationalId: data.nationalId,
      // gender: data.gender,

      // Call your API with the form data
      const response = await api.get(`Home/CompeleteProfile?MobileNumber=${phoneNumber}&OID=1&Fname=${data.firstName}&Lname=${data.lastName}&NationalCode=${data.nationalId}`);
      const resData=JSON.parse(response);
      // Check response and redirect on success
      if (response.status === 200) {
        navigate('/profile'); // Redirect to profile page
      }
    } catch (error) {
      console.error('Error during registration:', error);
    }
  };

  // Watch fields for changes (optional)
  const selectedDate = watch('birthDate');

  return (
    <section className="container maxw mb-4 pb-5">
      <div className="card login radius15 border-0 shadow-lg mx-md-5 mx-3 mt-5 justify-content-center">
        <div className="row">
          <div className="col-lg-6">
            <div className="card-body p-4 text-center">
              <a href="Index_demo1.html">
                <Logo
                  className={'pt-2 pb-4'}
                  style={{ filter: 'invert(100%)' }}
                  alt={'logo'}
                />
              </a>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <input
                    type="text"
                    {...register('firstName', { required: 'نام ضروری است' })}
                    className="form-control"
                    placeholder="نام"
                  />
                  {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    {...register('lastName', { required: 'نام خانوادگی ضروری است' })}
                    className="form-control"
                    placeholder="نام خانوادگی"
                  />
                  {errors.lastName && <span className="text-danger">{errors.lastName.message}</span>}
                </div>
                <div className="form-group mb-">
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      height: '26px',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    value={selectedDate}
                    maxDate={today}
                    onChange={(date) => setValue('birthDate', date.toDate())}
                    render={
                      <input
                        className="form-control"
                        placeholder={'تاریخ تولد'}
                      />
                    }
                  />
                  {errors.birthDate && <span className="text-danger">{errors.birthDate.message}</span>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    {...register('nationalId', { required: 'کد ملی ضروری است' })}
                    className="form-control"
                    placeholder="کد ملی"
                  />
                  {errors.nationalId && <span className="text-danger">{errors.nationalId.message}</span>}
                </div>
                <RadioGroup
                  row
                  aria-labelledby="gender-radio-buttons-group-label"
                  {...register('gender', { required: 'لطفا جنسیت خود را انتخاب کنید' })}
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="زن"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="مرد"
                  />
                </RadioGroup>
                {errors.gender && <span className="text-danger">{errors.gender.message}</span>}
                <button
                  type="submit"
                  style={{ marginTop: '100px' }}
                  className="btn btn-block btn-primary btn-nobat py-3 radius10 mb-4 w-25"
                >
                  عضویت
                </button>
              </form>
            </div>
          </div>
          <div className="col-lg-6 m-auto">
            <img
              src="/online-medical.png"
              className="img-fluid p-2 d-lg-block d-none"
              alt="Online Medical"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
